var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"已入驻商家","name":"first","lazy":true}},[_c('joined-business')],1),_c('el-tab-pane',{attrs:{"label":"入驻申请","name":"second"}},[_c('apply-business')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }